import { render, staticRenderFns } from "./EditPerimeterSecurityAnalytics.vue?vue&type=template&id=51b439ac"
import script from "./EditPerimeterSecurityAnalytics.vue?vue&type=script&lang=js"
export * from "./EditPerimeterSecurityAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports